import { useState, useRef, useEffect } from "react";
import Image from "../common/Image";
import targetIcon from "../../assets/images/landing/target.png";

const Objectives = ({ data, language = false }) => {
  return (
    <section id="objectives">
      <div className="max-w-7xl mx-auto overflow-hidden">
        {/* HEADER (same as Section design) */}
        <div className="w-full flex items-center justify-between cursor-pointer select-none px-4 font-semibold text-white">
          <div className="flex items-center gap-2">
            <h2 className="text-xl font-semibold mb-2 text-theme-color">
              {language ? "योजना के उद्देश्य" : "Scheme Objectives"}
            </h2>
          </div>
        </div>

        <div className="transition-all duration-700 ease-in-out overflow-hidden bg-white">
          <div className="p-6 grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
            {data.map((item, i) => (
              <div
                key={i}
                className={`bg-white shadow-md border-t-4 ${item.color} rounded-xl p-6`}
              >
                <Image
                  src={targetIcon}
                  alt="Target"
                  className="h-12 w-12 mb-4"
                />
                <p className="text-sm">
                  {language ? item.text.hi : item.text.en}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Objectives;
